export default __webpack_public_path__ + "static/media/documents_region_international.7816925d.svg";